import { createContext, useState } from "react";

export const PersonInfoContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    let emptyPersonInfo = {};

    const [personInfoDetail, setPersonInfoDetail] = useState(emptyPersonInfo);
    const [personInfo, setPersonInfo] = useState(emptyPersonInfo);
    const [personInfos, setPersonInfos] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [personInfoDialog, setPersonInfoDialog] = useState(false);
    const [personInfoHistoryDialog, setPersonInfoHistoryDialog] = useState(false);
    const [personInfoHistories, setPersonInfoHistories] = useState([]);

    const [infoHistoryCards, setInfoHistoryCards] = useState([]);
    const [infoHistoryPersons, setInfoHistoryPersons] = useState([]);
    const [changeType, setChangeType] = useState(null);

    const resetPersonInfo = () => {
        setPersonInfo(emptyPersonInfo);
    };

    // Make the context object:
    const personInfoContext = {
        personInfo,
        resetPersonInfo,
        setPersonInfo,
        personInfos,
        setPersonInfos,
        submitted,
        setSubmitted,
        personInfoDialog,
        setPersonInfoDialog,
        personInfoHistoryDialog,
        setPersonInfoHistoryDialog,
        personInfoHistories,
        setPersonInfoHistories,
        personInfoDetail,
        setPersonInfoDetail,
        infoHistoryCards,
        setInfoHistoryCards,
        infoHistoryPersons,
        setInfoHistoryPersons,
        changeType,
        setChangeType,
    };

    // pass the value in provider and return
    return <PersonInfoContext.Provider value={personInfoContext}>{children}</PersonInfoContext.Provider>;
};

export const { Consumer } = PersonInfoContext;
